export default __webpack_public_path__ + "static/media/96.3e41661b.jpeg";